import { setLocale } from 'yup';
import * as z from 'zod';

// Library-global configuration that must run before the libraries are used.
// Imported first in `app/main.jsx` and by `config/jest/jest.unit.setup.js`,
// so everything here must be import-order-safe and test-safe. Keep app
// initialization (i18next, analytics, DOM access) out — it belongs in main.

// Yup reads locale messages when a schema is built. Replace defaults that
// only make sense to developers.
setLocale({
    string: {
        // eslint-disable-next-line no-template-curly-in-string -- Yup interpolation, not a template literal
        trim: '${path} must not start or end with whitespace'
    }
});

// Avoid `new Function` at parse time, which CSP blocks.
z.config({ jitless: true });
